import ReactDOM from 'react-dom'
import { App } from './App'
import { BrowserRouter } from 'react-router-dom'
import store from './store'
import { Auth0Provider } from '@auth0/auth0-react'
import { Provider } from 'react-redux'
import { createRoot } from "react-dom/client";
import { AUTH0_DOMAIN, AUTH0_CLIENT_ID, AUTH0_AUDIENCE } from './environment/apis.config';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { FEATURE_FLAG_SUMMARY } from './environment/featureFlags'

// Mirrors the table the build printed for Jenkins, so a browser session can be
// matched to the flag set it was built with. See dist/feature-flags.json for the
// full resolved matrix of a deployed bundle.
// eslint-disable-next-line no-console
console.info(FEATURE_FLAG_SUMMARY)

const providerConfig = {
  domain: AUTH0_DOMAIN,
  clientId: AUTH0_CLIENT_ID,
  audience: AUTH0_AUDIENCE,
  authorizationParams: {
    redirect_uri: window.location.origin,
    ...(AUTH0_AUDIENCE ? { audience: AUTH0_AUDIENCE } : null),
  },
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
//if (process.env.NODE_ENV !== 'production') console.log = () => {}
// console.log("process.env.NODE_ENV:", process.env.NODE_ENV)
const root = createRoot(document.getElementById('root'));

const queryClient = new QueryClient()

root.render(
    <Auth0Provider {...providerConfig}>
      <Provider store={store}>
            <BrowserRouter>
            <QueryClientProvider client={queryClient}>
              <App />
              </QueryClientProvider>
            </BrowserRouter>
      </Provider>
    </Auth0Provider>
)
